import PriceQuotesPage from './PriceQuotesPage';

export default PriceQuotesPage;
